import React, { createRef, SyntheticEvent, useEffect, useState } from 'react';
import { AppContainer, AppContainerPage, AppContainerWrapper, PageHeader, Root } from './styledComponents';
import GlobalStyles from './styledComponents/styles';
import { detectScrollToBottom } from './helpers';
import {AuthScreen, NotFound, Page, StartScreen} from './components/pages';
import { authUser } from './actions/actions';
import { LoadingModal } from './components/modals';
import {IBCProps} from "./components/BasiqConnect";

function App(props:IBCProps) {
	const {test} = props;
	const ref = createRef<HTMLDivElement>();
	const [shadow, setShadow] = useState(false);
	const [currentScreen, setCurrentScreen] = useState(0);
	const [loading, setLoading] = useState(true);
	const [authId, setAuthId] = useState('');
	const [queryString, setQueryString] = useState('');
	const [mobile, setMobile] = useState('');
	const [logo, setLogo] = useState('');
	const [appName, setAppName] = useState('');
	const [errorCode, setErrorCode] = useState('');
	const [smsSent, setSmsSent] = useState(false);

	const handleConnectionsScroll = (event: SyntheticEvent<HTMLDivElement>) => {
		setShadow(detectScrollToBottom(event));
	};
	const showErrorScreen = (code: string) => {
		setErrorCode(code);
		setCurrentScreen(3);
	};
	useEffect(() => {
		const getData = async () => {
			const id = window.location.pathname.substring(1);
			setQueryString(window.location.search);
			if (id?.length > 0) {
				setAuthId(id);
				setLoading(true);
				const response = await authUser({authRequestId:id, method:'GET', test});
				if (response?.ok) {
					setCurrentScreen(1);
					setMobile(response?.data?.mobile);
					if (response?.data?.appName) {
						setAppName(response?.data?.appName);
					}
					if (response?.data?.partner?.logoUrl) {
						setLogo(response?.data?.partner?.logoUrl);
					}
				} else {
					showErrorScreen(response?.statusCode.toString());
				}
			} else {
				showErrorScreen('404');
			}
			setLoading(false);
		};
		getData();
	}, []);


	const getScreen = () => {
		switch (currentScreen) {
			case 0:
				return <Page shadow={shadow}><LoadingModal isOpen={loading} disableTransparency /></Page>;
			case 1:
				return (
					<StartScreen
						appName={appName}
						shadow={shadow}
						showErrorScreen={showErrorScreen}
						onContinue={() => setCurrentScreen(2)}
						authRequestId={authId}
						smsSent={smsSent}
						setSmsSent={setSmsSent}
						test={test}
					/>
				);
			case 2:
				return <AuthScreen number={mobile} onBack={() => setCurrentScreen(1)} shadow={shadow} authRequestId={authId} test={test} queryString={queryString}/>;
			case 3:
				return <NotFound messageCode={errorCode} />;
			default:
				return <NotFound messageCode={errorCode} />;
		}
	};

	return (
		<Root>
			<GlobalStyles />
			<AppContainerWrapper>
				<AppContainer onScroll={handleConnectionsScroll} ref={ref}>
					{logo && (
						<PageHeader>
							<img src={logo} alt="logo" />
						</PageHeader>
					)}
					<AppContainerPage>{getScreen()}</AppContainerPage>
				</AppContainer>
			</AppContainerWrapper>
		</Root>
	);
}

export default App;
